import React, { useContext, useState } from "react";
import {
    TitleWrapper,
    TitleText,
    StyledButton,
} from "../../../shared/styled/TitleBar";
import AddIcon from "../../../shared/svg/AddIcon";
import { useNavigate } from "react-router-dom";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { ROLE } from "../../../data/enums";
import { StyleButtonWrapper } from "../../../shared/components/TitleRow/Styled";
import { ExportModal } from "./ExportModal";
import apiMethods from "../../../utils/api";
import { ColumnMapping, downloadExcel } from "../../../utils/exportUtils";

const Title = () => {
    const navigate = useNavigate();
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);

    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canCreate = [ROLE.MANAGER, ROLE.SALE_STAFF].includes(role);

    const onClickAddButton = () => {
        navigate("/customers/create");
    };

    const onClickExport = async (value: number | undefined) => {
        try {
            // Fetch the data from the backend
            const data: any = await apiMethods.get(
                `/customers/summary-files?month=${value}`
            );

            // Check if the response is valid
            if (data && Array.isArray(data)) {
                const columnMapping: ColumnMapping = {
                    customer_code: "Mã khách hàng",
                    name: "Tên khách hàng",
                    category: "Loại khách hàng(Phuy/Thùng/Cơ Khí Ô tô)",
                    total_products_sold: "Tổng số lượng sản phẩm",
                    total_money_sold: "Tổng doanh thu",
                };

                // Download the excel file
                downloadExcel(
                    data,
                    columnMapping,
                    "Thống kê khách hàng",
                    "thong_ke_khach_hang"
                );
            }
        } catch (error) {
            console.error(
                "Error fetching or generating the Excel file:",
                error
            );
        }
    };

    return (
        <TitleWrapper>
            {isExportModalOpen && (
                <ExportModal
                    open={isExportModalOpen}
                    handleClose={() => setIsExportModalOpen(false)}
                    handleConfirm={(value: number | undefined) => {
                        onClickExport(value);
                        setIsExportModalOpen(false);
                    }}
                />
            )}

            <TitleText>Danh sách khách hàng</TitleText>

            <StyleButtonWrapper>
                <StyledButton
                    variant="outlined"
                    onClick={() => setIsExportModalOpen(true)}
                >
                    Xuất file
                </StyledButton>

                {canCreate && (
                    <StyledButton
                        variant="contained"
                        onClick={onClickAddButton}
                    >
                        <AddIcon />
                        Tạo mới khách hàng
                    </StyledButton>
                )}
            </StyleButtonWrapper>
        </TitleWrapper>
    );
};

export default Title;
